import HeroSectionV2 from "@/components/landing-v2/HeroSectionV2";
import BrutalTruthSection from "@/components/landing-v2/BrutalTruthSection";
import GetSavedSection from "@/components/landing-v2/GetSavedSection";
import ProfileShowcaseSection from "@/components/landing-v2/ProfileShowcaseSection";
import FreeTierSectionV2 from "@/components/landing-v2/FreeTierSectionV2";
import TestimonialsSectionV2 from "@/components/landing-v2/TestimonialsSectionV2";
import FooterV2 from "@/components/landing-v2/FooterV2";

const HomepageV2 = () => {
  return (
    <main className="min-h-screen bg-qcard-dark">
      <HeroSectionV2 />
      <BrutalTruthSection />
      <GetSavedSection />
      <ProfileShowcaseSection />
      <FreeTierSectionV2 />
      <TestimonialsSectionV2 />
      <FooterV2 />
    </main>
  );
};

export default HomepageV2;
